export class APIModel {
  id!: number;
}

export class FileField {
  filename!: string;
  content_type!: string;
  size!: number;
  files!: string[];
  file_id!: string;
  upload_storage!: string;
  uploaded_at!: string;
  path!: string;
  url!: string;
  saved!: boolean;
}

export class Project {
  static API = '/api/project/';
  id!: number;
  title?: string;
  created?: string;
  updated?: string;
  thumbnail?: FileField;
  owner_id!: number;
}

export class Node {
  static API = '/api/node/';
  id!: number;
  name?: string;
  style?: string;
  state?: string;
  task_id?: string;
  model?: string;
  pos_x?: number;
  pos_y?: number;
  project_id!: number;
  text?: string;
  content?: FileField;
  options?: any;
  sources?: number[];
  targets?: number[];
}

export class Job {
  static API = '/api/job/';
  id!: number;
  owner_id!: number;
  prompt?: string;
  text?: any;
  content?: FileField;
  options?: any;
  status?: string;
}

export class Chat {
  static API = '/api/chat/';
  id!: number;
  project_id!: number;
  role?: string;
  thinking?: string;
  content?: string;
}

export class Media {
  static API = '/api/media/';
  id!: number;
  file?: FileField;
  chat_id?: number;
}

export class Artifact {
  static API = '/api/artifact/';
  id!: number;
  chat_id!: number;
  type?: string;
  image?: FileField;
  title?: string;
  content?: string;
  is_saved_as_artifact?: boolean;
}

export class NodeHistory {
  static API = '/api/nodehistory/';
  id!: number;
  node_id!: number;
  content?: FileField;
  thumbnail?: FileField;
}

export class Prompt extends APIModel {
  static API = '/api/prompt/';
  key!: string;
  name!: string;
  description?: string;
  content!: string;
  version?: string;
  is_latest?: boolean;
  variables?: Record<
    string,
    {
      type: string;
      description: string;
      default?: any;
    }
  >;
  created_at?: string;
}
